import {
  createBalancesWithdrawTransfer,
  createTokensWithdrawnTransfer,
} from './createTransfer'
import type { HandleEventParameters, HandleEventReturnType } from './types'

export const handleTransactionFee = ({
  chain,
  timestamp,
  source,
  events,
  relatedAddresses,
  debug,
}: HandleEventParameters): HandleEventReturnType => {
  if (events.length === 0) {
    return undefined
  }
  const event = events[0]

  // balances.Withdraw event の場合
  if (event.section === 'balances' && event.method === 'Withdraw') {
    const transfer = createBalancesWithdrawTransfer({
      chain,
      data: event.data,
      relatedAddresses,
      debug,
    })
    if (!transfer) {
      return undefined
    }
    // action 生成して返す
    return {
      actions: [
        {
          type: 'transaction-fee',
          timestamp,
          source,
          order: 0,
          evidence: 'system-rule',
          transfers: [transfer],
        },
      ],
      unhandledEvents: events.slice(1),
    }
  }

  // tokens.Withdrawn event の場合
  if (event.section === 'tokens' && event.method === 'Withdrawn') {
    const transfer = createTokensWithdrawnTransfer({
      chain,
      data: event.data,
      relatedAddresses,
      debug,
    })
    if (!transfer) {
      return undefined
    }
    // action 生成して返す
    return {
      actions: [
        {
          type: 'transaction-fee',
          timestamp,
          source,
          order: 0,
          evidence: 'system-rule',
          transfers: [transfer],
        },
      ],
      unhandledEvents: events.slice(1),
    }
  }

  return undefined
}
